import React, { useEffect, useRef, useState } from 'react';
import { FaDownload, FaPowerOff, FaUser, FaUsers, FaBuilding } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { getUserData, getUserRole } from '../../helpers/local_storage_helpers';
import userAvatar from '../../assets/icons/user-avatar.png';
import { BsCloudSun } from 'react-icons/bs';
import { History, ActivitySquare } from 'lucide-react';
import { GiStatic } from 'react-icons/gi';
import { TbPhoneCalling } from 'react-icons/tb';
import { LeaderboardSharp } from '@mui/icons-material';

function ProfileDropdown({ logout }) {
    const [userData, setUserData] = useState({});
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Use ref to track dropdown
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        setIsDropdownOpen(false); // Close dropdown after logging out
        logout();
    };

    const handleHistory = () => {
        setIsDropdownOpen(false); // Close dropdown after navigating to history
        navigate('/account');
    };

    const handleDownloadSheets = () => {
        setIsDropdownOpen(false); // Close dropdown after navigating to history
        navigate('/download-sheets');
    };

    const handleWeather = () => {
        setIsDropdownOpen(false); // Close dropdown after navigating to history
        navigate('/weather');
    };

    const handleUserOrderHistory = () => {
        setIsDropdownOpen(false); // Close dropdown after navigating to history
        navigate('/user-order-history');
    };

    const handleLeadStats = () => {
        setIsDropdownOpen(false);
        navigate('/lead-stats');
    };

    const handleTelecalling = () => {
        setIsDropdownOpen(false);
        navigate('/telecalling');
    };

    const handleActiveView = () => {
        setIsDropdownOpen(false);
        navigate('/active-view');
    };

    const handleLeads = () => {
        setIsDropdownOpen(false);
        navigate('/leads');
    };

    // Close dropdown if clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setUserData(getUserData());
    }, []);

    return (
        <div className="relative">
            <div
                className="flex items-center space-x-1 text-primary fill-primary cursor-pointer gap-1 max-w-28"
                onClick={toggleDropdown}
            >
                <img
                    src={userData?.image || userAvatar}
                    alt="Profile"
                    className="profile-avatar max-h-10 aspect-square rounded-full"
                />
                <span className="hidden lg:flex truncate">
                    {userData?.first_name}
                </span>
            </div>

            {isDropdownOpen && (
                <div
                    className="absolute right-0 mt-2 w-52 z-50 pointer-events-auto"
                    ref={dropdownRef}
                >
                    <button
                        className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10  flex flex-row items-center gap-2"
                        onClick={handleHistory}
                    >
                        <FaUser />
                        Account Settings
                    </button>
                    {
                        getUserRole() === "admin" ?
                            <button
                                className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10  flex flex-row items-center gap-2"
                                onClick={handleDownloadSheets}
                            >
                                <FaDownload />
                                Download Sheets
                            </button> : <></>
                    }
                    {
                        getUserRole() === "admin" ?
                            <button
                                className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10  flex flex-row items-center gap-2"
                                onClick={handleWeather}
                            >
                                <BsCloudSun />
                                Weather
                            </button> : <></>
                    }
                    {getUserRole() === "admin" ?
                        <button
                            className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10  flex flex-row items-center gap-2"
                            onClick={handleUserOrderHistory}
                        >
                            <History />
                            User Order History
                        </button> : <></>
                    }

                    {/* Leads Related Items */}
                    {getUserRole() === "admin" && (
                        <button
                            className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row items-center gap-2"
                            onClick={handleLeadStats}
                        >
                            <GiStatic className="text-lg" />
                            Stats
                        </button>
                    )}

                    {(getUserRole() === "staff" || getUserRole() === "admin" || getUserRole() === "hr-admin") && (
                        <button
                            className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row items-center gap-2"
                            onClick={handleTelecalling}
                        >
                            <TbPhoneCalling className="text-lg" />
                            Telecalling
                        </button>
                    )}

                    {(getUserRole() === "staff" || getUserRole() === "admin" || getUserRole() === "hr-admin") && (
                        <button
                            className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row items-center gap-2"
                            onClick={handleActiveView}
                        >
                            <ActivitySquare className="text-lg" />
                            Active View
                        </button>
                    )}

                    {getUserRole() === "admin" && (
                        <button
                            className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row items-center gap-2"
                            onClick={handleLeads}
                        >
                            <LeaderboardSharp className="text-lg" />
                            Leads
                        </button>
                    )}

                    <button
                        className="w-full px-4 py-2 text-left text-red-600 bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row gap-2 items-center"
                        onClick={handleLogout}
                    >
                        <FaPowerOff />
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
}

export default ProfileDropdown;
